import { render, staticRenderFns } from "./extract-templates-page.vue?vue&type=template&id=48612918&scoped=true"
import script from "./extract-templates-page.vue?vue&type=script&lang=js"
export * from "./extract-templates-page.vue?vue&type=script&lang=js"
import style0 from "./extract-templates-page.vue?vue&type=style&index=0&id=48612918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48612918",
  null
  
)

export default component.exports